<template>
  <v-card variant="outlined" class="ncrm-external-api-contract-card">
    <v-card-title class="text-subtitle-1 font-weight-bold">
      {{ $t("ncrm.integrations.externalApi.contract.title") }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t("ncrm.integrations.externalApi.contract.subtitle") }}
    </v-card-subtitle>
    <v-card-text class="d-flex flex-column ga-4">
      <div class="d-flex flex-wrap ga-2">
        <v-chip color="primary">{{ contract.auth_header_name || "x-api-key" }}</v-chip>
        <v-chip color="secondary">{{ contract.content_type || "application/json" }}</v-chip>
        <v-chip color="info">{{ contract.payload_mode || "single_object" }}</v-chip>
        <v-chip color="success">store_only</v-chip>
      </div>

      <div>
        <div class="text-caption text-medium-emphasis mb-2">
          {{ $t("ncrm.integrations.externalApi.contract.requiredFields") }}
        </div>
        <div class="d-flex flex-wrap ga-2">
          <v-chip
            v-for="field in contract.required_body_fields || []"
            :key="`required-${field}`"
            variant="outlined"
          >
            {{ field }}
          </v-chip>
        </div>
      </div>

      <div>
        <div class="text-caption text-medium-emphasis mb-2">
          {{ $t("ncrm.integrations.externalApi.contract.recommendedFields") }}
        </div>
        <div class="d-flex flex-wrap ga-2">
          <v-chip
            v-for="field in contract.recommended_body_fields || []"
            :key="`recommended-${field}`"
            variant="outlined"
          >
            {{ field }}
          </v-chip>
        </div>
      </div>

      <div>
        <div class="text-caption text-medium-emphasis mb-2">
          {{ $t("ncrm.integrations.externalApi.contract.scopesTitle") }}
        </div>
        <div class="ncrm-external-api-contract-card__scope-grid">
          <div>
            <div class="font-weight-medium mb-2">company</div>
            <div class="d-flex flex-wrap ga-2">
              <v-chip
                v-for="field in contract.company_recommended_fields || []"
                :key="`company-${field}`"
                size="x-small"
              >
                {{ field }}
              </v-chip>
            </div>
          </div>
          <div>
            <div class="font-weight-medium mb-2">person</div>
            <div class="d-flex flex-wrap ga-2">
              <v-chip
                v-for="field in contract.person_recommended_fields || []"
                :key="`person-${field}`"
                size="x-small"
              >
                {{ field }}
              </v-chip>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="text-caption text-medium-emphasis mb-2">
          {{ $t("ncrm.integrations.externalApi.contract.limitationsTitle") }}
        </div>
        <div class="d-flex flex-column ga-2">
          <div
            v-for="entry in contract.limitations || []"
            :key="entry"
            class="text-body-2 text-medium-emphasis"
          >
            {{ entry }}
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "NcrmExternalApiContractCard",
  props: {
    contract: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
.ncrm-external-api-contract-card__scope-grid {
  display: grid;
  gap: 16px;
}

@media (min-width: 960px) {
  .ncrm-external-api-contract-card__scope-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
